import React, { useEffect, useState } from "react";
import Footerdeo from "../shared/Footerdeo";
import Navbardeo from "../shared/Navbardeo";
import Sidebardeo from "../shared/Sidebardeo";
import axios from "axios";
import config from "../../config";

function DEOdashboard() {
  const [dashboardCounts, setDashboardCounts] = useState({
    pending: 0,
    approved: 0,
    rejected: 0,
    total_school: 0,
  });
  const [loading, setLoading] = useState(true); // Loading state for the dashboard
  useEffect(() => {
    // ==================Fetching Dashboard Count Data==================
    const fetchDashboardCounts = async () => {
      try {
        const deoId = sessionStorage.getItem("deoId");
        const token = sessionStorage.getItem("deotoken");

        if (!deoId || !token) {
          console.error("Missing deoId or token in sessionStorage");
          return;
        }

        const response = await axios.post(
          `${config.API_BASE_URL}/DEODashboardPendingApprovedRejctCount_CL9`,
          { deO_ID: deoId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (
          response.data?.status === 200
          // response.data.data?.DEOPendingApprovedRejct_status
        ) {
          const {
            approved = 0,
            pending = 0,
            rejected = 0,
            totaL_SCHOOLS = 0,
            tickeR_TITLE = "",
          } = response.data.data.deoPendingApprovedRejct_status;
          setLoading(false); // Stop loading when data is fetched
          setDashboardCounts({
            pending: pending,
            approved: approved,
            rejected: rejected,
            total_school: totaL_SCHOOLS,
            ticker_title: tickeR_TITLE,
          });
        } else {
          console.error("Unexpected API response:", response.data);
        }
      } catch (error) {
        setLoading(false); // Stop loading on error
        console.error("Error fetching dashboard count data:", error);
      }
    };

    fetchDashboardCounts();
  }, []);

  return (
    <div className="container-scroller">
      <Navbardeo />
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-fluid page-body-wrapper">
        <Sidebardeo />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <div className="row">
                  <div className="col-12 col-xl-12 mb-4 mb-xl-0">
                    <h3
                      className="font-weight-bold"
                      style={{ textTransform: "uppercase" }}
                    >
                      Dashboard
                    </h3>
                    {/* <h6
                        className="font-weight-normal mb-2"
                        style={{ textTransform: "uppercase" }}
                      >
                        District - BOKARO, JHARKHAND
                      </h6> */}
                  </div>
                  {dashboardCounts.ticker_title && (
                    <div
                      className="col-12 col-xl-12 mb-4 mb-xl-0"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <marquee
                          className="marq"
                          direction="left"
                          scrollamount="8"
                          style={{
                            color: "red",
                            fontWeight: 500,
                            padding: 10,
                            fontSize: 20,
                          }}
                        >

                          {dashboardCounts.ticker_title || ""}
                        </marquee>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Dashboard Cards */}
            <div className="row">
              {/* Pending */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card">
                <div className="card card-dark-blue text-white">
                  <a
                    href="/deo-pending-for-approval"
                    className="card-body text-white text-decoration-none"
                  >
                    <div className="row">
                      <div className="col-md-9">
                        <h3 className="mb-2">
                          {dashboardCounts.pending || "0"}
                          <small style={{ fontSize: "14px" }}></small>
                        </h3>
                        <p className="mb-2 mt-2" style={{ fontSize: "18px" }}>
                          Pending for Approval
                        </p>
                      </div>
                      <div className="col-md-3 text-center">
                        <i
                          className="fa fa-graduation-cap icon-large"
                          style={{ fontSize: "34px" }}
                        ></i>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

              {/* Approved */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card">
                <div className="card bg-success text-white">
                  <a
                    href="/deo-total-approved"
                    className="card-body text-white text-decoration-none"
                  >
                    <div className="row">
                      <div className="col-md-9">
                        <h3 className="mb-2">
                          {dashboardCounts.approved || "0"}
                        </h3>
                        <p className="mb-2 mt-2" style={{ fontSize: "18px" }}>
                          Total Approved
                        </p>
                      </div>
                      <div className="col-md-3 text-center">
                        <i
                          className="fa fa-check-square-o icon-large"
                          style={{ fontSize: "34px" }}
                        ></i>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

              {/* Rejected */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card">
                <div className="card card-light-danger">
                  <a
                    href="/deo-rejected"
                    className="card-body text-decoration-none"
                  >
                    <div className="row">
                      <div className="col-md-9">
                        <h3 className="mb-2">
                          {dashboardCounts.rejected || "0"}
                        </h3>
                        <p className="mb-2 mt-2" style={{ fontSize: "18px" }}>
                          Total Rejected
                        </p>
                      </div>
                      <div className="col-md-3 text-center">
                        <i
                          className="fa fa-times-circle-o icon-large"
                          style={{ fontSize: "34px" }}
                        ></i>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

              {/* Total Schools */}
              <div className="col-md-3 col-xl-3 mb-4 stretch-card">
                <div className="card card-tale">
                  <a
                    href="/total-schools"
                    className="card-body text-decoration-none"
                  >
                    <div className="row">
                      <div className="col-md-9">
                        <h3 className="mb-2">
                          {dashboardCounts.total_school || "0"}
                        </h3>
                        <p className="mb-2 mt-2" style={{ fontSize: "18px" }}>
                          Total School
                        </p>
                      </div>
                      <div className="col-md-3 text-center">
                        <i
                          className="fa fa-building-o icon-large"
                          style={{ fontSize: "34px" }}
                        ></i>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <Footerdeo />
        </div>
      </div>
    </div>
  );
}

export default DEOdashboard;
